import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const ErrorBanner = ({ message, classBlockName }) => (
    <div className={classBlockName}>
        <span className={`${classBlockName}__copy`}>
            { message }
        </span>
        <div className={`${classBlockName}__callout`}></div>
    </div>
);

ErrorBanner.defaultProps = {
    classBlockName: 'bs-errorBanner',
};

ErrorBanner.propTypes = {
    message: PropTypes.string.isRequired,
    classBlockName: PropTypes.string.isRequired,
};

export default ErrorBanner;



// WEBPACK FOOTER //
// /src/js/common/errorBanner/ErrorBanner.jsx